module.exports = __webpack_public_path__ + "img/苏州市旧机动车交易市场有限公司.c4c978cf.jpg";